import React, { Fragment } from "react"
import _map from "lodash/map"

import classnames from "classnames"
import styles from "./styles.css"

const TABLE_COLUMNS = 7

const TicketManagerSkeleton = () => {
  const skeletonClasses = classnames(styles.skeleton)
  const containerClasses = classnames(styles.container, styles.commons)

  return (
    <Fragment>
      <div className={containerClasses}>
        <div className={styles.header}>
          <div className={classnames(skeletonClasses)} />
          <div className={classnames(styles.headerTitle, skeletonClasses)} />
        </div>

        <div className={styles.filtersRow}>
          {_map(Array(4), (_, index) => (
            <div
              key={index}
              className={classnames(
                styles.filterField,
                index === 2 && styles.filterFieldLarge,
                index === 3 && styles.filterButton,
                skeletonClasses
              )}
            />
          ))}
        </div>

        <div className={classnames(styles.searchField, skeletonClasses)} />

        <div className={styles.clearFiltersRow}>
          <div className={classnames(styles.clearFilters, skeletonClasses)} />
        </div>

        <div className={styles.tabsWrapper}>
          <div className={styles.tabs}>
            <div className={styles.tabItem}>
              <div
                className={classnames(
                  styles.tabText,
                  styles.tabTextActive,
                  skeletonClasses
                )}
              />
            </div>

            <div className={styles.tabItem}>
              <div className={classnames(styles.tabText, skeletonClasses)} />
            </div>
          </div>

          <div className={styles.tabsDivider} />
        </div>

        <div className={styles.tables}>
          <div className={styles.tableHeader}>
            {_map(Array(TABLE_COLUMNS), (_, index) => (
              <div
                key={index}
                className={classnames(styles.tableHeaderCell, skeletonClasses)}
              />
            ))}
          </div>

          <div className={styles.tableBody}>
            {_map(Array(8), (_, rowIndex) => (
              <div key={rowIndex} className={styles.tableRow}>
                {_map(Array(TABLE_COLUMNS), (_, colIndex) => (
                  <div
                    key={colIndex}
                    className={classnames(
                      styles.tableCell,
                      colIndex === TABLE_COLUMNS - 1 && styles.tableIconCell,
                      skeletonClasses
                    )}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.pagination}>
          {_map(Array(5), (_, index) => (
            <div
              key={index}
              className={classnames(
                styles.paginationItem,
                index === 2 && styles.paginationItemActive,
                index === 5 && styles.paginationItemWide,
                skeletonClasses
              )}
            />
          ))}
        </div>
      </div>
    </Fragment>
  )
}

export default TicketManagerSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/TicketManagerSkeleton/index.js